/**
 * connectivitystatereducer.js
 * Created by calhosh on 8/27/2020.
 */
import initialState from './initialstate';

export default function connectivityStateReducer(state = initialState.connectivitystate, action) {
	switch (action.type) {
		case 'SET_CONNECTIVITY_STATE':
			/* Notice that this is simply returning the action payload, <%=names.camel%>.
			 * This is because the combineReducers() call wraps this reducer
			 * and passes it only the portion of the store state that it
			 * is concerned with. */
			console.log(`[${action.type}]: appOnlineState reducer -`, action);
			return action.response.isOnline;
		default:
			return state;
	}
}
